/**
 * Created by hrachG on 4/30/2018.
 */

import { actionTypes } from './../Constants/constants';
import { ApiUrls, GlobalUrls } from './../Constants/constants';
import { AjaxUtils } from './../utils';
import { AxiosResponse } from 'axios';
import { startLoadingPage, endLoadingPage } from './masterActions';


export function loadHomePageData() {
    return (dispatch: any, getState: any) => {
        dispatch(startLoadingPage());
        AjaxUtils.axiosGet(ApiUrls.LoadHomePage, {}).then((response: AxiosResponse) => {
            dispatch(endLoadingPage());
            if (response != null && response.data != null) {
                dispatch({
                    type: actionTypes.homePageDataLoaded,
                    HomeModel: response.data
                });
            }
            else {
                dispatch({
                    type: actionTypes.homePageDataFailedToLoad,
                    HomePageFaliedToLoad: true
                });
            }
        });
    };
}


// WEBPACK FOOTER //
// ./ClientApp/app/Actions/homeActions.tsx